const onPremDevDomain = 'https://wwwdev.troweprice.com';
const onPremFisDevDomain = 'https://www.rpsdev.troweprice.com';

export default {
  DEV: {
    INTERNAL: {
      api: 'https://api.dev.awstrp.net',
      web: 'https://www.dev.awstrp.net',
      wrs: onPremDevDomain,
      fisapi: 'https://api.rpsdev.fisretirement.net',
      fisweb: 'https://www.rpsdev.fisretirement.net',
      fiswrs: onPremFisDevDomain,
    },
    EXTERNAL: {
      api: 'https://api.dev.troweprice.com',
      web: 'https://wwwdev.troweprice.com',
      wrs: onPremDevDomain,
      fisapi: 'https://api.rpsdev.troweprice.com',
      fisweb: 'https://www.rpsdev.troweprice.com',
      fiswrs: onPremFisDevDomain,
    },
  },
  STAGE: {
    INTERNAL: {
      api: 'https://api.stage.awstrp.net',
      web: 'https://www.stage.awstrp.net',
      wrs: 'https://www.stage.awstrp.net',
      fisapi: 'https://api.rpsstg.fisretirement.net',
      fisweb: 'https://www.rpsstg.fisretirement.net',
      fiswrs: 'https://www.rpsstg.fisretirement.net',
    },
    EXTERNAL: {
      api: 'https://api.confidence.troweprice.com',
      web: 'https://wwwstage.troweprice.com',
      wrs: 'https://wwwstage.troweprice.com',
      fisapi: 'https://api.rpsstg.troweprice.com',
      fisweb: 'https://www.rpsstg.troweprice.com',
      fiswrs: 'https://www.rpsstg.troweprice.com',
    },
  },
  PROD: {
    INTERNAL: {
      api: 'https://api.prod.awstrp.net',
      web: 'https://www.prod.awstrp.net',
      wrs: 'https://www.troweprice.com',
      fisapi: 'https://api.rps.fisretirement.net',
      fisweb: 'https://www.rps.fisretirement.net',
      fiswrs: 'https://www.rps.troweprice.com',
    },
    EXTERNAL: {
      api: 'https://api.public.troweprice.com',
      web: 'https://www.troweprice.com',
      wrs: 'https://www.troweprice.com',
      fisapi: 'https://api.rps.troweprice.com',
      fisweb: 'https://www.rps.troweprice.com',
      fiswrs: 'https://www.rps.troweprice.com',
    },
  },
  SANDBOX: {
    EXTERNAL: {
      api: 'https://api.dev.troweprice.com',
      web: 'https://wwwdev.troweprice.com',
      wrs: onPremDevDomain,
      fisapi: 'https://api.rpsdev.troweprice.com',
      fisweb: 'https://www.rpsdev.troweprice.com',
      fiswrs: onPremFisDevDomain,
    },
  },
  LOCALHOST: {
    INTERNAL: {
      api: '',
      web: 'https://www.dev.awstrp.net',
      wrs: onPremDevDomain,
      fisapi: '',
      fisweb: 'https://www.rpsdev.fisretirement.net',
      fiswrs: onPremFisDevDomain,
    },
    EXTERNAL: {
      api: '',
      web: 'https://wwwdev.troweprice.com',
      wrs: onPremDevDomain,
      fisapi: '',
      fisweb: 'https://www.rpsdev.troweprice.com',
      fiswrs: onPremFisDevDomain,
    },
  },
};
